<template>
    <div class="content">
        <el-collapse v-model="activeName" accordion>
            <el-collapse-item
                :title="item.title"
                :name="index"
                v-for="(item, index) in dataList"
                :key="index"
            >
                <div>
                    {{ item.body }}
                </div>
            </el-collapse-item>
        </el-collapse>
    </div>
</template>

<script>
import { listQuestion } from '@/api/index'

export default {
    data() {
        return {
            dataList: [],
            activeName: '1'
        }
    },
    created() {
        this.init()
    },
    methods: {
        init() {
            listQuestion().then((res) => {
                if (res.code == 0) {
                    this.dataList = res.data
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.content {
    padding: 24px;
    box-sizing: border-box;
}
</style>